jQuery(document).ready(function ($) {
	addMainImg();

	addIntersectionObserver();
	$(window).resize(function () {
		addMainImg();
	});

	function addIntersectionObserver() {
		console.log("adding observer");
		let observer = new IntersectionObserver(
			(entries) => {
				// console.log("entries", entries);
				entries.forEach((entry) => {
					// console.log(entry);
					if (entry.isIntersecting) {
						entry.target.play();
					} else {
						entry.target.pause();
					}
				});
			},
			{
				threshold: [0, 0.01],
			}
		);

		[...document.querySelectorAll("#mainvid, .associated-image-video")].forEach(
			(el) => observer.observe(el)
		);
	}

	function addMainImg() {
		console.log('debug:', window.screen.width);
		if (window.innerWidth >= 768) {
			console.log("debug: screen is > 767");
			$(".main-product-imagery").removeClass("hidden");
			const firstEl = document.querySelector(".vslide-images li");
			const type = firstEl.getAttribute("data-type");
			const target =
				type === "image"
					? $(".main-product-imagery #mainimg")
					: $(".main-product-imagery #mainvid");
			const other =
				type !== "image"
					? $(".main-product-imagery #mainimg")
					: $(".main-product-imagery #mainvid");
			const url =
				type === "image"
					? firstEl.querySelector("img").getAttribute("src")
					: firstEl.querySelector("video").getAttribute("src");
			$(target).attr("src", url);
			$(target).removeClass("hidden");
			$(other).addClass("hidden");
		} else {
			console.log("debug: hide the main product imagery");
			$(".main-product-imagery").addClass("hidden");
		}
		// const el = $(".vslide-images img");
		// console.log(9, el);
		// $activeimg = $(".vslide-images img").attr("src");
		// $screenwidth = window.screen.width;
		// if ($screenwidth > 767) {
		// 	if (!$("#mainimg").length) {
		// 		$(".vslide").prepend('<img id="mainimg" src="' + $activeimg + '" />');
		// 	}
		// 	$(".vslide img").on("click", function () {
		// 		$("#mainimg").prop("src", this.src);
		// 	});
		// } else {
		//   $('.main-product-imagery').addClass('hidden');
		// 	if ($("#mainimg").length) {
		// 		$("#mainimg").remove();
		// 	}
		// }

		addIntersectionObserver();
	}

	[...document.querySelectorAll(".vslide img")].forEach((el) => {
		el.addEventListener("click", (e) => {
			const { currentTarget } = e;
			const parent = currentTarget.closest("[data-type]");
			const type = parent.getAttribute("data-type");

			const target =
				type === "image"
					? $(".main-product-imagery #mainimg")
					: $(".main-product-imagery #mainvid");
			const other =
				type !== "image"
					? $(".main-product-imagery #mainimg")
					: $(".main-product-imagery #mainvid");
			const url =
				type === "image"
					? parent.querySelector("img").getAttribute("src")
					: parent.querySelector("video").getAttribute("src");
			$(target).attr("src", url);
			$(target).removeClass("hidden");
			$(other).addClass("hidden");
		});
	});
	$(".vslide img").on("click", function () {
		$("#mainimg").prop("src", this.src);
	});

	var $scrollup = $("#scroll-up");
	var $scrolldown = $("#scroll-down");
	var $scrollimages = $(".vslide-images");
	let scrollimagesH = $scrollimages.innerHeight();

	$scrollup.hide();
	$scrolldown.show();

	$scrolldown.click(function (event) {
		event.preventDefault();
		$scrollimages.animate({ scrollTop: "+=" + scrollimagesH }, 300);
	});
	$scrollup.click(function (event) {
		event.preventDefault();
		$scrollimages.animate({ scrollTop: "-=" + scrollimagesH }, 300);
	});

	$scrollimages.scroll(function () {
		var scrollHeight = $scrollimages[0].scrollHeight;

		if ($scrollimages.scrollTop() >= 30) {
			$scrollup.fadeIn(100);
			$scrolldown.hide();
		} else {
			$scrollup.fadeOut(100);
		}

		if (scrollHeight - scrollimagesH > $scrollimages.scrollTop()) {
			$scrolldown.show();
		}
	});
});
